import { render, staticRenderFns } from "./DefSearch.vue?vue&type=template&id=b0d7ee8e&scoped=true&"
import script from "./DefSearch.vue?vue&type=script&lang=js&"
export * from "./DefSearch.vue?vue&type=script&lang=js&"
import style0 from "./DefSearch.vue?vue&type=style&index=0&id=b0d7ee8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d7ee8e",
  null
  
)

export default component.exports